export const STALE_CONTACTS_RULES = ["status = 'Stale'", 'Status = Stale'];
export const BLOCKED_CONTACTS_RULES = ['Status = Bounced OR Status = Unsubscribed OR Status = Abuse'];
